<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">
        {{ modalLabel }}
      </div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="refrigaretedTruckAddEditForm">
      <div class="field-validation-error"></div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required">
            <div class="services-form">
              <input
                formControlName="refrigaredName"
                type="text"
                maxlength="50"
                placeholder="RefrigaredName"
              />
              <label>Refrigerated name</label>
              <div
                *ngIf="submitted && refrigaretedTruckAddEditForm.controls['refrigaredName'].errors"
              >
                <div
                  *ngIf="refrigaretedTruckAddEditForm.controls['refrigaredName'].errors?.['required']"
                  class="input-error"
                >
                  Name is required
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required">
            <div class="services-form">
              <input
                formControlName="fuelConsumpiton"
                type="number"
                maxlength="10"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                placeholder="fuel Consumpiton"
              />
              <label>Fuel consumption</label>
              <div
                *ngIf="submitted && refrigaretedTruckAddEditForm.controls['fuelConsumpiton'].errors"
              >
                <div
                  *ngIf="refrigaretedTruckAddEditForm.controls['fuelConsumpiton'].errors?.['required']"
                  class="input-error"
                >
                  This field is required
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="form-group required">
            <label
              *ngIf="refrigaretedTruckAddEditForm.get('organizationName')?.value"
              class="sub-header-drpdown pb-2"
              >Organization</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #organization
              [items]="organizationlist"
              [searchable]="false"
              bindLabel="name"
              formControlName="organizationName"
              [searchFn]="commonInputSearchOrganization"
              placeholder="All organization"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="organization.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (refrigaretedTruckAddEditForm.controls['organizationName']?.touched &&
                  refrigaretedTruckAddEditForm.controls['organizationName']?.invalid) ||
                refrigaretedTruckAddEditForm.controls['organizationName'].value?.name ===
                  'Organization' ||
                (submitted &&
                  !refrigaretedTruckAddEditForm.controls['organizationName'].value?.name)
              "
              class="input-error"
            >
              Organization is required.
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer text-margin">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
